import { AvailabilitySchedule } from 'gql/autogen/AvailabilitySchedule';

export enum NavigationHashEnum {
    OverviewSection = '#overview-section',
    PackageOptionsSection = '#package-options-section',
    WhatsIncludedSection = '#what-s-included-section',
    SimCardSpecSection = '#sim-card-spec-section',
    IntroductionSummarySection = '#introduction-summary-section',
    DepartureReturnSection = '#departure-return-section',
    WhatToExpectSection = '#what-to-expect-section',
    SuggestedRouteSection = '#suggested-route-section',
    AdditionalInfoSection = '#additional-info-section',
    CancellationPolicySection = '#cancellation-policy-section',
    ReviewSection = '#review-section',
    FAQsSection = '#faqs-section',
    EmbeddedSsrSection = '#activity-list',
    LocationSection = '#location-section',
    AboutActivitySection = '#about-activity-section',
}

export type ExpandedAccordionDict = Record<string, boolean>;

export const defaultExpandedAccordion: ExpandedAccordionDict = {
    '#overview-section': false,
    '#package-options-section': false,
    '#what-s-included-section': true,
    '#sim-card-spec-section': false,
    '#introduction-summary-section': false,
    '#departure-return-section': false,
    '#what-to-expect-section': false,
    '#suggested-route-section': false,
    '#additional-info-section': false,
    '#cancellation-policy-section': false,
    '#faqs-section': false,
    '#review-section': true,
};

export interface ActivityOfferToken {
    activityToken: string;
    enableOfferFilter: boolean;
}

export enum ExpandabilityState {
    Expanded = 1,
    Collapsed = 2,
}

export type OfferLevelSchedule = Omit<AvailabilitySchedule, 'offers'>;
